import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment-timezone'

import { cloneGallery } from '@/lib/utils'

import submitPlatformPost from '@/graphql/mutations/submissions/submitPlatformPost.gql'
import reschedulePlatformPost from '@/graphql/mutations/submissions/reschedulePlatformPost.gql'
import deletePlatformPost from '@/graphql/mutations/submissions/deletePlatformPost.gql'
import duplicatePlatformPost from '@/graphql/mutations/submissions/duplicatePlatformPost.gql'

import allLinkedInSubmissions from '@/graphql/queries/linkedin/allLinkedInSubmissions.gql'
import linkedinPost from '@/graphql/queries/linkedin/linkedinPost.gql'

export default {
  code: 'linkedin',
  name: 'LinkedIn',
  icon: 'linkedin',
  color: '#0077B5',
  accountNoun: 'Profile',
  postNoun: 'Post',
  internalPostNoun: 'LinkedInPost',
  mutations: {
    submitPost: submitPlatformPost,
    submitPostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    deletePost: deletePlatformPost,
    deletePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    reschedulePost: reschedulePlatformPost,
    reschedulePostVariables: (submission) => {
      return {
        postId: submission.postId,
        platform: submission.platform.toUpperCase()
      }
    },
    duplicatePost: duplicatePlatformPost
  },
  queries: {
    allSubmissions: allLinkedInSubmissions,
    getPost: linkedinPost
  },
  posts: {
    preparePostForScheduling: (post, publishingStatus = 'READY_TO_PUBLISH') => {
      let clonedGallery = cloneDeep(post.gallery)
      let gallery = null
      if (clonedGallery) {
        gallery = {
          id: clonedGallery.id,
          galleryMediaSet: []
        }
        gallery.galleryMediaSet = clonedGallery.galleryMediaSet.map(
          (mediaSet) => {
            return {
              id: mediaSet.id,
              order: mediaSet.order,
              media: {
                name: mediaSet.media.name,
                url: mediaSet.media.url,
                externalId: mediaSet.media.externalId,
                mimeType: mediaSet.media.mimeType,
                size: mediaSet.media.size,
                source: mediaSet.media.source
              }
            }
          }
        )
      }

      let submissions = post.submissions.map((submission) => {
        return {
          id: submission.id,
          postAt: submission.postAt
        }
      })

      return {
        id: post.id,
        username: post.username,
        gallery,
        text: post.text,
        link: post.link,
        visibility: post.visibility,
        publishingStatus,
        submissions
      }
    },
    createPost(socialAccount) {
      return {
        id: null,
        username: socialAccount.username,
        text: '',
        link: '',
        visibility: 'PUBLIC',
        publishingStatus: 'READY_TO_PUBLISH',
        gallery: {
          id: null,
          galleryMediaSet: []
        },
        submissions: [
          {
            postAt: moment().add(1, 'hour').startOf('hour').toDate()
          }
        ]
      }
    },
    getPost(post) {
      return {
        caption: post.text,
        text: post.text,
        gallery: cloneGallery(post.gallery),
        postAt: moment(post.submissions[0].postAt).toDate()
      }
    },
    syncField(post, field, value, socialAccount) {
      if (field === 'caption') {
        post.text = value
      } else if (field === 'text') {
        post.text = value
      } else if (field === 'gallery') {
        post.gallery = cloneDeep(value)
      } else if (field === 'postAt') {
        post.submissions[0].postAt = value
      } else if (field === 'thread') {
        if (value.length > 0) {
          let text = value[0].text
          if (text) {
            post.text = text
          }

          let gallery = value[0].gallery
          if (gallery) {
            post.gallery = cloneDeep(gallery)
          }
        }
      }
      return post
    },
    syncCoverImage(post, media) {
      const gallery = post.gallery
      if (gallery && gallery.galleryMediaSet.length > 0) {
        gallery.galleryMediaSet.forEach((mediaItem) => {
          if (mediaItem.media.id === media.id) {
            mediaItem.media.coverImage = media.coverImage
          }
        })
      }
      return post
    }
  }
}
